/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as AuthenticatedDebugRouteImport } from './routes/_authenticated/debug'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/index'
import { Route as AuthenticatedOrganizationsOrgIdIndexRouteImport } from './routes/_authenticated/organizations/$orgId/index'
import { Route as AuthenticatedViewBookIdChapterNumberRouteImport } from './routes/_authenticated/view/$bookId/$chapterNumber'
import { Route as AuthenticatedTranslationBookIdChapterNumberRouteImport } from './routes/_authenticated/translation/$bookId/$chapterNumber'
import { Route as AuthenticatedAudioBookIdChapterNumberRouteImport } from './routes/_authenticated/audio/$bookId/$chapterNumber'
import { Route as AuthenticatedProjectsProjectIdMilestonesMilestoneIdRouteImport } from './routes/_authenticated/projects/$projectId/milestones/$milestoneId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalRoute,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalRoute,
} as any)
const AuthenticatedDebugRoute = AuthenticatedDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdIndexRoute =
  AuthenticatedProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsOrgIdIndexRoute =
  AuthenticatedOrganizationsOrgIdIndexRouteImport.update({
    id: '/organizations/$orgId/',
    path: '/organizations/$orgId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedViewBookIdChapterNumberRoute =
  AuthenticatedViewBookIdChapterNumberRouteImport.update({
    id: '/view/$bookId/$chapterNumber',
    path: '/view/$bookId/$chapterNumber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTranslationBookIdChapterNumberRoute =
  AuthenticatedTranslationBookIdChapterNumberRouteImport.update({
    id: '/translation/$bookId/$chapterNumber',
    path: '/translation/$bookId/$chapterNumber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAudioBookIdChapterNumberRoute =
  AuthenticatedAudioBookIdChapterNumberRouteImport.update({
    id: '/audio/$bookId/$chapterNumber',
    path: '/audio/$bookId/$chapterNumber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute =
  AuthenticatedProjectsProjectIdMilestonesMilestoneIdRouteImport.update({
    id: '/projects/$projectId/milestones/$milestoneId',
    path: '/projects/$projectId/milestones/$milestoneId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/debug': typeof AuthenticatedDebugRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/audio/$bookId/$chapterNumber': typeof AuthenticatedAudioBookIdChapterNumberRoute
  '/translation/$bookId/$chapterNumber': typeof AuthenticatedTranslationBookIdChapterNumberRoute
  '/view/$bookId/$chapterNumber': typeof AuthenticatedViewBookIdChapterNumberRoute
  '/organizations/$orgId/': typeof AuthenticatedOrganizationsOrgIdIndexRoute
  '/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/projects/$projectId/milestones/$milestoneId': typeof AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute
}
export interface FileRoutesByTo {
  '/accept-invitation': typeof AcceptInvitationRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/debug': typeof AuthenticatedDebugRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/audio/$bookId/$chapterNumber': typeof AuthenticatedAudioBookIdChapterNumberRoute
  '/translation/$bookId/$chapterNumber': typeof AuthenticatedTranslationBookIdChapterNumberRoute
  '/view/$bookId/$chapterNumber': typeof AuthenticatedViewBookIdChapterNumberRoute
  '/organizations/$orgId': typeof AuthenticatedOrganizationsOrgIdIndexRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/projects/$projectId/milestones/$milestoneId': typeof AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/debug': typeof AuthenticatedDebugRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/audio/$bookId/$chapterNumber': typeof AuthenticatedAudioBookIdChapterNumberRoute
  '/_authenticated/translation/$bookId/$chapterNumber': typeof AuthenticatedTranslationBookIdChapterNumberRoute
  '/_authenticated/view/$bookId/$chapterNumber': typeof AuthenticatedViewBookIdChapterNumberRoute
  '/_authenticated/organizations/$orgId/': typeof AuthenticatedOrganizationsOrgIdIndexRoute
  '/_authenticated/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/_authenticated/projects/$projectId/milestones/$milestoneId': typeof AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/legal'
    | '/login'
    | '/reset-password'
    | '/debug'
    | '/legal/privacy'
    | '/legal/terms'
    | '/organizations/'
    | '/projects/'
    | '/users/'
    | '/audio/$bookId/$chapterNumber'
    | '/translation/$bookId/$chapterNumber'
    | '/view/$bookId/$chapterNumber'
    | '/organizations/$orgId/'
    | '/projects/$projectId/'
    | '/projects/$projectId/milestones/$milestoneId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invitation'
    | '/legal'
    | '/login'
    | '/reset-password'
    | '/debug'
    | '/legal/privacy'
    | '/legal/terms'
    | '/'
    | '/organizations'
    | '/projects'
    | '/users'
    | '/audio/$bookId/$chapterNumber'
    | '/translation/$bookId/$chapterNumber'
    | '/view/$bookId/$chapterNumber'
    | '/organizations/$orgId'
    | '/projects/$projectId'
    | '/projects/$projectId/milestones/$milestoneId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/accept-invitation'
    | '/legal'
    | '/login'
    | '/reset-password'
    | '/_authenticated/debug'
    | '/legal/privacy'
    | '/legal/terms'
    | '/_authenticated/'
    | '/_authenticated/organizations/'
    | '/_authenticated/projects/'
    | '/_authenticated/users/'
    | '/_authenticated/audio/$bookId/$chapterNumber'
    | '/_authenticated/translation/$bookId/$chapterNumber'
    | '/_authenticated/view/$bookId/$chapterNumber'
    | '/_authenticated/organizations/$orgId/'
    | '/_authenticated/projects/$projectId/'
    | '/_authenticated/projects/$projectId/milestones/$milestoneId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  LegalRoute: typeof LegalRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof LegalRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof LegalRoute
    }
    '/_authenticated/debug': {
      id: '/_authenticated/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof AuthenticatedDebugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/': {
      id: '/_authenticated/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/$orgId/': {
      id: '/_authenticated/organizations/$orgId/'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId/'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/view/$bookId/$chapterNumber': {
      id: '/_authenticated/view/$bookId/$chapterNumber'
      path: '/view/$bookId/$chapterNumber'
      fullPath: '/view/$bookId/$chapterNumber'
      preLoaderRoute: typeof AuthenticatedViewBookIdChapterNumberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/translation/$bookId/$chapterNumber': {
      id: '/_authenticated/translation/$bookId/$chapterNumber'
      path: '/translation/$bookId/$chapterNumber'
      fullPath: '/translation/$bookId/$chapterNumber'
      preLoaderRoute: typeof AuthenticatedTranslationBookIdChapterNumberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audio/$bookId/$chapterNumber': {
      id: '/_authenticated/audio/$bookId/$chapterNumber'
      path: '/audio/$bookId/$chapterNumber'
      fullPath: '/audio/$bookId/$chapterNumber'
      preLoaderRoute: typeof AuthenticatedAudioBookIdChapterNumberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/milestones/$milestoneId': {
      id: '/_authenticated/projects/$projectId/milestones/$milestoneId'
      path: '/projects/$projectId/milestones/$milestoneId'
      fullPath: '/projects/$projectId/milestones/$milestoneId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdMilestonesMilestoneIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDebugRoute: typeof AuthenticatedDebugRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedAudioBookIdChapterNumberRoute: typeof AuthenticatedAudioBookIdChapterNumberRoute
  AuthenticatedTranslationBookIdChapterNumberRoute: typeof AuthenticatedTranslationBookIdChapterNumberRoute
  AuthenticatedViewBookIdChapterNumberRoute: typeof AuthenticatedViewBookIdChapterNumberRoute
  AuthenticatedOrganizationsOrgIdIndexRoute: typeof AuthenticatedOrganizationsOrgIdIndexRoute
  AuthenticatedProjectsProjectIdIndexRoute: typeof AuthenticatedProjectsProjectIdIndexRoute
  AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute: typeof AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDebugRoute: AuthenticatedDebugRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedAudioBookIdChapterNumberRoute:
    AuthenticatedAudioBookIdChapterNumberRoute,
  AuthenticatedTranslationBookIdChapterNumberRoute:
    AuthenticatedTranslationBookIdChapterNumberRoute,
  AuthenticatedViewBookIdChapterNumberRoute:
    AuthenticatedViewBookIdChapterNumberRoute,
  AuthenticatedOrganizationsOrgIdIndexRoute:
    AuthenticatedOrganizationsOrgIdIndexRoute,
  AuthenticatedProjectsProjectIdIndexRoute:
    AuthenticatedProjectsProjectIdIndexRoute,
  AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute:
    AuthenticatedProjectsProjectIdMilestonesMilestoneIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface LegalRouteChildren {
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  LegalRoute: LegalRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
